export default "/info-icon.0b5cf61f4e74cc1a17bd3e940ebf0296.svg";